import getParameterByName from './getParameterByName'

export default props => ({
  slug: props.match.params.slug,
  signature:
    (props.staticContext && props.staticContext.signature) || getParameterByName('signature', props.location.search),
})
